// @ts-nocheck
import React, { useEffect, useRef } from 'react';
function SetHtmlContent(_a) {
  var html = _a.html;
  var divRef = useRef(null);
  useEffect(function () {
    if (!html) return;
    var slotHtml = document.createRange().createContextualFragment(html);
    divRef.current.innerHTML = '';
    divRef.current.appendChild(slotHtml);
  }, [html]);
  return React.createElement("div", {
    ref: divRef
  });
}
var QualtricsScript = function (_a) {
  var projectId = _a.projectId;
  if (projectId === '') {
    return null;
  }
  var projectIdToUrl = function (projectId) {
    return projectId.replace(/_/g, '').toLowerCase();
  };
  var html = "\n  <!--BEGIN QUALTRICS WEBSITE FEEDBACK SNIPPET-->\n  <script type='text/javascript'>\n    (function(){var g=function(e,h,f,g){\n    this.get=function(a){for(var a=a+\"=\",c=document.cookie.split(\";\"),b=0,e=c.length;b<e;b++){for(var d=c[b];\" \"==d.charAt(0);)d=d.substring(1,d.length);if(0==d.indexOf(a))return d.substring(a.length,d.length)}return null};\n    this.set=function(a,c){var b=\"\",b=new Date;b.setTime(b.getTime()+6048E5);b=\"; expires=\"+b.toGMTString();document.cookie=a+\"=\"+c+b+\"; path=/; \"};\n    this.check=function(){var a=this.get(f);if(a)a=a.split(\":\");else if(100!=e)\"v\"==h&&(e=Math.random()>=e/100?0:100),a=[h,e,0],this.set(f,a.join(\":\"));else return!0;var c=a[1];if(100==c)return!0;switch(a[0]){case \"v\":return!1;case \"r\":return c=a[2]%Math.floor(100/c),a[2]++,this.set(f,a.join(\":\")),!c}return!0};\n    this.go=function(){if(this.check()){var a=document.createElement(\"script\");a.type=\"text/javascript\";a.src=g;document.body&&document.body.appendChild(a)}};\n    this.start=function(){var t=this;\"complete\"!==document.readyState?window.addEventListener?window.addEventListener(\"load\",function(){t.go()},!1):window.attachEvent&&window.attachEvent(\"onload\",function(){t.go()}):t.go()};};\n    try{(new g(100,\"r\",\"QSI_S_" + projectId + "\",\"https://" + projectIdToUrl(projectId) + "-olxbr.siteintercept.qualtrics.com/SIE/?Q_ZID=" + projectId + "\")).start()}catch(i){}})();\n    </script><div id='" + projectId + "'><!--DO NOT REMOVE-CONTENTS PLACED HERE--></div>\n    <!--END WEBSITE FEEDBACK SNIPPET-->\n  ";
  return React.createElement(SetHtmlContent, {
    html: html
  });
};
export default QualtricsScript;
export var sendQualtricsEvent = function (eventName) {
  if (typeof window === 'object') {
    window._qsie = window._qsie || [];
    window._qsie.push(eventName);
  }
};
export var evaluateQualtricsIntercepts = function () {
  if (window.QSI && window.QSI.API) {
    window.QSI.API.unload();
    window.QSI.API.load().then(window.QSI.API.run);
  }
};